// extracted by mini-css-extract-plugin
export var toastContainer = "Notification-module--toastContainer--WfOQS";
export var toastContainerError = "Notification-module--toastContainerError--3Iqs0";
export var toastContainerSuccess = "Notification-module--toastContainerSuccess--tf1IS";
export var notification = "Notification-module--notification--okuF2";
export var icon = "Notification-module--icon--Kas3A";
export var alert = "Notification-module--alert--7DlPn";
export var message = "Notification-module--message--QFCPa";
export var extra = "Notification-module--extra--+uMln";
export var caption = "Notification-module--caption--2v+qq";
export var link = "Notification-module--link--SBJZw";